import styled from 'styled-components';

import { ContentSpacing } from '@estee/elc-base-theme';
import { Body2 } from '@estee/elc-typography';
import { inheritBaseFont } from '~theme/default-theme';

const { space4, space12 } = ContentSpacing;

export const StyledDefaultKitItemWrapper = styled.div`
    display: flex;
    flex-direction: row;
    gap: ${space12};
`;

export const StyledDefaultKitDescription = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: flex-start;
    gap: ${space4};
`;

export const StyledDefaultKitImageWrapper = styled.img`
    align-self: flex-start;
    margin: 0;
    min-width: 40px;
    width: 40px;
`;

export const StyledDefaultKitProductSub = styled(Body2)`
    text-overflow: ellipsis;
    white-space: break-spaces;
    width: inherit;
    overflow: hidden;
    ${inheritBaseFont};
`;
